module.exports = __webpack_public_path__ + "static/img/surface13.6216e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface13.png
// module id = e6qO
// module chunks = 2